import axios from '@/api/axios'

// 服务器代理地址
const BASE_URL = process.env.VUE_APP_BASE_URL

// ===================================《 机构分销 》

// 机构-列表
export function agencyList(parameter) {
  return axios({
    url: BASE_URL + '/xt/provider_list',
    method: 'get',
    params: parameter
  })
}

// 机构-检索
export function agencySearch(parameter) {
  return axios({
    url: BASE_URL + '/xt/provider_all',
    method: 'get',
    params: parameter
  })
}

// 机构-创建/编辑
export function agencySave(parameter) {
  return axios({
    url: BASE_URL + '/xt/provider_save',
    method: 'post',
    data: parameter
  })
}

// 团长-列表
export function leaderList(parameter) {
  return axios({
    url: BASE_URL + '/xt/leader_list',
    method: 'get',
    params: parameter
  })
}

// 团长-检索
export function leaderSearch(parameter) {
  return axios({
    url: BASE_URL + '/xt/leader_all',
    method: 'get',
    params: parameter
  })
}

// 团长-创建/编辑 
export function leaderSave(parameter) {
  return axios({
    url: BASE_URL + '/xt/leader_save',
    method: 'post',
    data: parameter
  })
}

// 达人-列表
export function talentList(parameter) {
  return axios({
    url: BASE_URL + '/xt/daren_list',
    method: 'get',
    params: parameter
  })
}

// 达人-添加编辑
export function talentSave(parameter) {
  return axios({
    url: BASE_URL + '/xt/daren_save',
    method: 'post',
    data: parameter
  })
}
